import Vue from 'vue'
import Component from 'vue-class-component'
import AddButton from '../buttons/AddButton.vue'
import convoStore from '@/store/convo/convo-store'
import { IStatement } from '@/model/statement'

@Component({
  name: 'statementConvoAdd',
  props: ['convo', 'statement'],
  components: { 'add-button' : AddButton },
})
export default class StatementConvoAdd extends Vue {

  protected addConvoStatement(): void {
    convoStore.dispatchAddConvoStatement(this.$props['statement'])
  }

}
